import { error } from "jquery";
import { getHeaders, checkStatus } from "../../../Services/SharedSevices/SharedServices"
import axios from "axios";
import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;

export const VerifyUser = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Auth/verifyuser`, body, {
      headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_API_BASE_KEY}`,
        'Content-Type': 'application/json',
      },
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const postSendOTP = async (body) => {
  try {
    const response = await axios.post(`${baseURL}/Auth/send-otp`, body, {
      headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_API_BASE_KEY}`,
        'Content-Type': 'application/json',
      },
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postLoginOTP = async (body) => {
  try {
    const response = await axios.post(`${baseURL}/Auth/login/otp`, body, {
       headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_API_BASE_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const loginByPassword = async (body) => {
  try {
    const response = await axios.post(`${baseURL}/Auth/login/password`, body, {
       headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_API_BASE_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const signUp = (body) => { 
  return fetch({
    method: 'POST',
    url: `${baseURL}/sign-up`,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
};

export async function ChangePassword(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Auth/change-password`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
}

export async function postLogOut(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Auth/logout`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
}

export async function SaveDevice(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Device/Save`,params, {      
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
}


